import React from 'react'

import ELocale from '../../types/locales'

const AppContext = React.createContext<TAppContext>({
  locale: ELocale.DE_DE,
})

export type TAppContext = {
  locale: ELocale
}

AppContext.displayName = 'AppContext'

export default AppContext
